<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="width:40%; padding-left: 15px;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table v-if="initvalue!=null" style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Deposit Num</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.depositnum }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Deposit Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.depositdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ deposit_type }}</b></h4></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table v-if="initvalue!=null" style="width: 100%;">
        <tr>
          <td v-if="initvalue.vendorid!=null" style="width:45%; padding-left: 15px; vertical-align: top;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Vendor</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.vendorname }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.vendoraddress }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.vendorphone }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.vendormobile }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold;">Deposit Type</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.deposittype }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Deposit Account</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_account }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_location }}</span></td>
              </tr>

              <tr>
                <td style="vertical-align: top;"><span style="font-size: 11pt; font-weight: bold;">Ref Num</span></td>
                <td style="text-align: right; max-width: 120px;"><span style="font-size: 11pt;">{{ initvalue.refnum }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table v-if="initvalue!=null" style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="20px">#</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="25%">Order Num</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="30%">Name</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Reference</th>
            <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid" width="15%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, i) in initvalue.transactions"  v-bind:key="trans._id">
            <td style="vertical-align: top;">{{ i+1  }}</td>
            <td style="vertical-align: top;">{{ trans.transclass=='Discount' ? `${trans.transclass}: ${trans.transtype} ${trans.transnum}` : `${trans.transtype} ${trans.transnum}` }}</td>
            <td style="vertical-align: top;">{{ trans.transname }}</td>
            <td style="vertical-align: top;">{{ trans.refnum }}</td>
            <td style="vertical-align: top; text-align: right">{{ getTransAmount(trans).toFixed(2) }}</td>
          </tr>
          <tr><td colspan="5" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr>
            <td colspan="5" style="vertical-align: text-top; ">
              <table width="100%">
                <tr>
                  <td style="max-width: 200px; vertical-align: top;"><p style="margin:0"><strong>Note:</strong></p> <span style="white-space: pre">{{ initvalue.depositnote }}</span></td>
                  <td width="40%" style="align-content: start;">
                    <table width="100%">
                      <tr>
                        <td style="text-align: right"><span style="font-size: 11pt; font-weight: bold">Subtotal:</span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.deposittotal.toFixed(2) }}</span></td>
                      </tr>
                      <tr v-if="initvalue.depositdiscount!=null && initvalue.depositdiscount!=0">
                        <td style="text-align: right"><span style="font-size: 11pt; font-weight: bold">Discount:</span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ (0-getDiscountAmount()).toFixed(2) }}</span></td>
                      </tr>
                      <tr>
                        <td style="text-align: right"><span style="font-size: 11pt; font-weight: bold">Deposit Total:</span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ getDepositAmount().toFixed(2) }}</span></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr><td colspan="5">&nbsp;</td></tr>

        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../../util/tools';

export default {
  name: 'PrintBatchDeposit',
  props: {
    id: String,
    type: String,
  },
  data() {
    return {
      logo: null,
      deposit_type: null,
      initvalue: null,
      data_company: {},
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getBatchDepositRequest', 'getCompanyDataRequest']),
    getCompanySetting(code, name){
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    convertCurrency(amount){
      let rate = parseFloat(this.initvalue.currencyRate);
      if(rate==null) rate = 0;
      return amount * rate;
    },
    getDepositAmount(){
      let subtotal = this.initvalue.deposittotal!=null ? this.initvalue.deposittotal: 0;
      let discount = this.initvalue.depositdiscount!=null ? this.initvalue.depositdiscount: 0;
      let result = subtotal-discount;
      return result!=null ? result : 0; 
    },
    getDiscountAmount(){
      let discount = this.initvalue.depositdiscount!=null ? this.initvalue.depositdiscount: 0;
      return discount; 
    },
    getTransAmount(item){
      let result;
      if(item.transclass=='Discount') result = item.transdiscount!=null ? (0-item.transdiscount) : 0; 
      else result = item.transamount!=null ? (0+item.transamount) : 0;
      return result!=null ? result : 0; 
    },
  },
  computed: {
    data_account(){
      if(this.data_company.accounts==null || this.data_company.accounts.lenght==0) return null;
      let account = this.data_company.accounts.find(i=>i._id == this.initvalue.accountid);
      if(account!=null) return account['accountname'];
      return '';
    },
    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.lenght==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationname'];
      return '';
    },
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getBatchDepositRequest(this.id);
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
      if(this.type!=undefined){
        if(this.type=='depositreceipt') this.deposit_type = 'Deposit Receipt';
        else this.deposit_type = 'Batch Deposit'
      }
    }
  },
}

</script>

<style src="./../Print.scss" lang="scss"/>
